<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Inquiry Request
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.inquirer_first_name"
                outlined
                label="Inquirer First Name"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.inquirer_first_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.father_name"
                outlined
                label="Father Name"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.father_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.vehicle_engine_number"
                outlined
                label="Engine Number"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.vehicle_engine_number"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.vehicle_chasi_number"
                outlined
                label="Chasi Number"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.vehicle_chasi_number"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.fuel_type"
                outlined
                label="Fuel Type"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.fuel_type"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.kilometer"
                outlined
                label="Kilometer"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.kilometer"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.inquirer_email"
                outlined
                label="Inquirer Email"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.inquirer_email"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.inquirer_phone"
                outlined
                label="Inquirer Phone"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.inquirer_phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-textarea
                v-model="form.address"
                outlined
                label="Address"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.address"
              ></v-textarea>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="position"
                outlined
                v-model="form.position_id"
                :items="positionItems"
                label="Position *"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                :error-messages="errors.position_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="status"
                outlined
                v-model="form.status"
                :items="statusItems"
                label="Status"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.status"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="user"
                outlined
                v-model="form.user_id"
                :items="userItems"
                label="User"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.user_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-menu
                v-model="menu"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.reminder_date"
                    label="Reminder Date"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.reminder_date"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <h2>Working Details</h2>
          <br />
          <v-row>
            <v-col sm="3">
              <v-text-field
                v-model="form.state_location"
                outlined
                label="State"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.state_location"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-text-field
                v-model="form.city"
                outlined
                label="City"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.city"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-text-field
                v-model="form.area"
                outlined
                label="Allocate Area"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.area"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-text-field
                v-model="form.pin_code"
                outlined
                label="Pin Code"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.pin_code"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Point Mapping
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "InquiryRequestCreatePage",
  data() {
    return {
      form: {
        inquirer_first_name: "",
        inquirer_middle_name: "",
        inquirer_last_name: "",
        inquirer_email: "",
        inquirer_phone: "",
        inquirer_address: "",
        reminder_date: "",
      },
      statusItems: [
        { text: "Pending", value: 0 },
        { text: "Completed", value: 1 },
        { text: "Reject", value: 2 },
      ],
      userItems: [],
      positionItems: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`inquiry_requests/masters`)
        .then((masters) => {
          masters = masters.data;
          //Users
          masters.users.forEach((user) => {
            this.userItems.push({
              id: user.id,
              text: user.user_name,
              value: user.id,
            });
          });
          //Position
          masters.positions.forEach((position) => {
            this.positionItems.push({
              id: position.id,
              text: position.name,
              value: position.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          window.location.href = "/auth/login";
        });
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/inquiry_requests", this.form);
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.push("/inquiry-requests");
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
